// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Stdlib from "melange/stdlib.js";
import * as Stdlib__Random from "melange/random.js";
import * as React from "react";

const _map = {"default":"default","success":"success","warning":"warning","loading":"loading"};

function kindToJs(param) {
  return param;
}

function kindFromJs(param) {
  return _map[param];
}

Stdlib__Random.init(Date.now() | 0);

function generateId(param) {
  return Stdlib__Random.$$int(1000000);
}

function initValue_1(param) {
  
}

const initValue = [
  /* [] */ 0,
  initValue_1
];

const context = React.createContext(initValue);

function useToasts(param) {
  return React.useContext(context);
}

const ToastsContext = {
  initValue: initValue,
  context: context,
  useToasts: useToasts
};

const make = context.Provider;

function makeProps(value, children, param) {
  return {
    value: value,
    children: children
  };
}

const ToastsProvider = {
  make: make,
  makeProps: makeProps
};

function useToastsContext(initialToasts) {
  const match = React.useReducer((function (toasts, action) {
    if (/* tag */ typeof action === "number" || typeof action === "string") {
      return /* [] */ 0;
    }
    if (action.TAG === /* Add */ 0) {
      return Stdlib.$at(toasts, {
        hd: action._0,
        tl: /* [] */ 0
      });
    }
    const id = action._0;
    return Belt__Belt_List.keep(toasts, (function (t) {
      return t.id !== id;
    }));
  }), initialToasts);
  return [
    match[0],
    match[1]
  ];
}

export {
  kindToJs,
  kindFromJs,
  generateId,
  ToastsContext,
  ToastsProvider,
  useToastsContext,
}
/*  Not a pure module */
